import { Party } from './../../../../../models/party-manager/party';
import { PartyService } from './../../../../../services/api/party/party.service';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDataElement } from 'src/app/models/interface/template/templateDataElement';
import { Mapping } from 'src/app/models/interface/template/mapping';
import { TemplateData } from 'src/app/models/interface/template/templateData';
import { TemplatesService } from 'src/app/services/api/templates/templates.service';
import { NotificationsService, NotificationLevel } from 'src/app/services/api/notifications/notifications.service';
import { CatalogService} from 'src/app/services/api/catalog/catalog.service';
import { ServiceTemplate } from 'src/app/models/interface/serviceTemplate/serviceTemplate';

@Component({
  selector: 'app-dialog-edit-template',
  templateUrl: './dialog-edit-template.component.html',
  styleUrls: ['./dialog-edit-template.component.scss']
})
export class DialogEditTemplateComponent implements OnInit {

  combos = {
    isp: null,
    type: null,
    ont: null,
    service: null,
    method: null
  };

  form: FormGroup;

  tooltip = {
    submit: '',
    reset: ''
  };

  displayedColumns = [
    'territoryUser',
    'territoryOwner',
    'externalTemplateISP',
    'externalTemplateINO'
  ];

  tiles: any[];

  inos: Party[];
  isps: Party[];

  previousIsp: string;
  previousServiceName: string;
  previousServiceTemplate: string;
  initialValue: string;

  dataSource: MatTableDataSource<Mapping>;
  @ViewChild(MatPaginator, null) paginator: MatPaginator;
  @ViewChild(MatSort, null) sort: MatSort;

  serviceTemplates: ServiceTemplate[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TemplateDataElement,
    public dialogRef: MatDialogRef<DialogEditTemplateComponent>,
    private translate: TranslateService,
    private templatesService: TemplatesService,
    private notificationsService: NotificationsService,
    private catalogService: CatalogService,
    private translateService: TranslateService,
    private partyService:PartyService
  ) {
  }

  ngOnInit() {
    this.initialValue = this.data.element.value;

    this.form = new FormGroup({
      isp: new FormControl('', Validators.required),
      serviceName: new FormControl('', Validators.required),
      serviceTemplate: new FormControl('', Validators.required)
    });

    this.catalogService.getServiceTemplates().subscribe(
      (data) => {
        this.serviceTemplates = data.content;
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('SERVICE_TEMPLATES_KEY.error'), NotificationLevel.ERROR);
      }
    );

    this.dataSource = null;
    const templateTypes = this.data.isps;
    this.inos = this.data.inos;
    this.isps = this.data.isps;

    if(!this.data.inos){
      this.partyService.getProviders().subscribe(p => this.inos=p);
    }
    
    templateTypes.sort
      (
        (n1, n2) => n1.name.toLowerCase() < n2.name.toLowerCase() ? -1 : 1
      );
    this.initTooltips();


    this.initForm(templateTypes, this.data.element);

  }

  private initForm(data: any[], template: TemplateData) {
    this.form.controls['isp'].setValue(template.mappings[0].territoryUser);
    this.form.controls['serviceName'].setValue(template.value);
    this.form.controls['serviceTemplate'].setValue(template.serviceTemplate);
    this.previousIsp = template.mappings[0].territoryUser;
    this.previousServiceName = this.form.controls['serviceName'].value;
    this.previousServiceTemplate = this.form.controls['serviceTemplate'].value;
  }
  

  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.submit = this.translate.instant('TOOLTIPS.submitForm');
      this.tooltip.reset = this.translate.instant('TOOLTIPS.resetForm');
    });
  }

  public submitForm() {
    const mappingData: Mapping[] = [];
    mappingData.push({
      territoryOwner: this.inos.find(p=> p.name ==="ADAMO").namingId,
      territoryReseller: this.form.controls['isp'].value,
      territoryUser: this.form.controls['isp'].value,
      externalTemplateISP: this.form.controls['serviceName'].value,
      externalTemplateINO: this.form.controls['serviceName'].value,
      tv: this.form.controls['serviceName'].value.includes('TV'),
    });

    const template: TemplateData = {
      value: this.form.controls['serviceName'].value,
      isActive: true,
      serviceTemplate: this.form.controls['serviceTemplate'].value,
      mappings: mappingData
    }
    const body = {
      id: this.data.element.id,
      template
    };
    this.templatesService.editTemplate(body)
      .subscribe(
        () => {
          this.notificationsService.showNotification(`Template ${this.previousServiceName} modificada correctamente`, NotificationLevel.SUCCESS);
          this.dialogRef.close();
        },
        (error) => {
          this.notificationsService.showNotification(
            `Ha habido un problema al editar el template:\n${error.error.errorDesc.message}`, NotificationLevel.ERROR);
        });
  }

  clearForm() {
    this.form.controls['isp'].setValue(this.previousIsp);
    this.form.controls['serviceName'].setValue(this.previousServiceName);
    this.form.controls['serviceTemplate'].setValue(this.previousServiceTemplate);
  }

}
